export const pathToFollowList = [
  { label: "Check Address", path: "/" },
  { label: "Choose Plan", path: "/choosePlan" },
  { label: "Add-ons", path: "/addOns" },
  { label: "Create Account", path: "/createAccount" },
  { label: "Schedule", path: "/schedule" },
  { label: "Summary", path: "/summary" },
  { label: "Make Payment", path: "/makePayment" },
];
